import Container from '@/components/base/Container';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';

export default function HomeFaq() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <div>
            <SectionHeading
              eyebrow="FAQ"
              title="关于追踪，你可能想问"
              desc="先了解一下我们的更新机制与内容原则，再决定要不要长期跟。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-question-answer-line text-primary-600"></i>
                没找到答案？
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                可以在页面底部留言告诉我们你想了解的细节，我们会补充进说明里。
              </p>
            </div>
          </div>
          <div>
            <FaqAccordion items={faqs} />
          </div>
        </div>
      </Container>
    </section>
  );
}